import React, { useEffect, useState } from 'react'
import { Backdrop } from 'src/global'
import {
  Modal,
  Header,
  CloseButtonWrapper,
  ModalContent,
  ModalFooter,
  CloseButtonLineOne,
  CloseButtonLineTwo,
} from '../../../HomeScreen/ProductModal/styles'
import { faCheck, faCopy, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from 'src/global/Button'
import { User } from '@meniudigital/shared'
import { Stepper, PriceDisplay, EmailPreview, PreviewWrapper, CopyButton } from './styles'
import reverseString from 'src/helpers/reverseString'

const MIN_LEVEL = 1
const MAX_LEVEL = 20
const DEFAULT_LEVEL = 4
const PRICE_PER_LEVEL = 50

function buildEmailBody(username: string, level: number) {
  const code = reverseString(`ONBOARDING-PACKAGE-L${level}`)
  const link = `${window.location.origin}/onboarding-package?u=${username}&p=${code}`
  return `Am primit materialele pentru digitalizarea meniului și le-am verificat. Totul arată bine și avem ce ne trebuie ca să începem.\n\nPentru a demara digitalizarea meniului dumneavoastră, vă rugăm să efectuați plata pachetului de Digitalizare accesând linkul de mai jos:\n\n${link}\n\nPuteți plăti cu cardul sau prin transfer bancar, iar factura o putem emite pe firmă sau PF.\n\nImediat ce primim confirmarea plății, începem configurarea meniului.`
}

export default function OnboardingPaymentEmailModal() {
  const [isOpen, setIsOpen] = useState(false)
  const [username, setUsername] = useState('')
  const [level, setLevel] = useState(DEFAULT_LEVEL)
  const [hasCopied, setHasCopied] = useState(false)

  useEffect(() => {
    window.openOnboardingPaymentEmailModal = open
  }, [])

  useEffect(() => {
    if (!hasCopied) {
      return
    }

    const timer = setTimeout(() => setHasCopied(false), 1500)
    return () => clearTimeout(timer)
  }, [hasCopied])

  const open = (user: User) => {
    setUsername(user.username)
    setLevel(DEFAULT_LEVEL)
    setHasCopied(false)
    setIsOpen(true)
  }

  const close = () => {
    setIsOpen(false)
  }

  const decrement = () => {
    setLevel(current => Math.max(MIN_LEVEL, current - 1))
    setHasCopied(false)
  }

  const increment = () => {
    setLevel(current => Math.min(MAX_LEVEL, current + 1))
    setHasCopied(false)
  }

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(buildEmailBody(username, level))
      setHasCopied(true)
    } catch {
      window.showModal({
        title: 'Eroare',
        text: 'Nu am putut copia în clipboard. Copiază manual textul.',
        confirmButtonText: 'Ok',
        isConfirm: true,
      })
    }
  }

  const price = level * PRICE_PER_LEVEL
  const emailBody = buildEmailBody(username, level)

  return (
    <>
      <Backdrop onClick={close} className={isOpen ? 'open' : 'closed'} />
      <Modal style={{ width: '480px' }} className={isOpen ? 'open' : 'closed'}>
        <Header>
          Text Confirmare Digitalizare
          <CloseButtonWrapper onClick={close} title="Închide">
            <CloseButtonLineOne />
            <CloseButtonLineTwo />
          </CloseButtonWrapper>
        </Header>
        <ModalContent>
          <Stepper>
            <button type="button" onClick={decrement} disabled={level <= MIN_LEVEL} title="Mai puțin">
              <FontAwesomeIcon icon={faMinus} />
            </button>
            <PriceDisplay>
              <span className="level">L{level}</span>
              <span className="price">{price} RON</span>
            </PriceDisplay>
            <button type="button" onClick={increment} disabled={level >= MAX_LEVEL} title="Mai mult">
              <FontAwesomeIcon icon={faPlus} />
            </button>
          </Stepper>
          <PreviewWrapper>
            <EmailPreview>{emailBody}</EmailPreview>
            <CopyButton type="button" className={hasCopied ? 'copied' : ''} onClick={copyEmail} title="Copiază emailul">
              <FontAwesomeIcon icon={hasCopied ? faCheck : faCopy} />
            </CopyButton>
          </PreviewWrapper>
        </ModalContent>
        <ModalFooter>
          <Button onClick={close} text="Gata" icon={faCheck} />
        </ModalFooter>
      </Modal>
    </>
  )
}
